import { GetterTree } from 'vuex';
import State from './state';
import RootState from '../../state'

const getters: GetterTree<State, RootState> = {

};

export default getters;


// WEBPACK FOOTER //
// ./static-content/private/javascripts/store/modules/memberInteriorSettings/getters.ts